// extracted by mini-css-extract-plugin
export var formContainer = "_fa-0";
export var message = "_fa-1";